const RepairFileStatusDetailConstant = {
  //--- REPAIR FILE CREATION ---//
  // STEP 1 VALIDATED
  PRODUCT_SELECTED: 'PRODUCT_SELECTED',
  // STEP 2 VALIDATED
  BREAKDOWN_EVALUATED: 'BREAKDOWN_EVALUATED',
  // STEP 3 VALIDATED
  GUARANTEE_EVALUATED: 'GUARANTEE_EVALUATED',
  // STEP 4 IN PROGRESS
  PRICING_SENT_TO_CUSTOMER: 'PRICING_SENT_TO_CUSTOMER',
  // STEP 4 VALIDATED
  PRICING_EVALUATED: 'PRICING_EVALUATED',

  // REPAIR STATUS
  // STEP 5 VALIDATED
  INFORMATION_RETRIEVED: 'INFORMATION_RETRIEVED',

  // STEP 6 REPAIR VALIDATED
  // STEP 5 PROSPECT VALIDATED
  INTERNAL_COMMAND_NUMBER_LINKED: 'INTERNAL_COMMAND_NUMBER_LINKED',

  // PROSPECT STATUS
  // STEP 6.1 VALIDATED
  PROSPECT_CLIENT_INFORMATION_RETRIEVED: 'PROSPECT_CLIENT_INFORMATION_RETRIEVED',
  // STEP 6.2 VALIDATED
  PROSPECT_REQUEST_SENT: 'PROSPECT_REQUEST_SENT',
  PROSPECT_MANUFACTURER_RESPONSE: 'PROSPECT_MANUFACTURER_RESPONSE',
  // STEP 6.3 VALIDATED
  PROSPECT_MANUFACTURER_RESPONSE_VALIDATED: 'PROSPECT_MANUFACTURER_RESPONSE_VALIDATED',

  // STEP 7 VALIDATED
  TRANSPORTER_REPAIR_FILE_TRANSFER: 'TRANSPORTER_REPAIR_FILE_TRANSFER',
  FINALIZE_REPAIR_FILE: 'FINALIZE_REPAIR_FILE',

  //--- REPAIR FILE DETAIL ---//
  REPAIR_FILE_CREATED: 'REPAIR_FILE_CREATED',
  COLLECTION_TO_REPAIRER: 'COLLECTION_TO_REPAIRER',

  RECEPTION_AT_REPAIRER: 'RECEPTION_AT_REPAIRER',

  DIAGNOSTIC_MANUFACTURER_RECEIVED: 'DIAGNOSTIC_MANUFACTURER_RECEIVED',

  ESTIMATE_CREATED: 'ESTIMATE_CREATED', // MACRO: DIAGNOSTIC_MANUFACTURER_PROCESSED
  FORCE_ESTIMATE_CREATED: 'FORCE_ESTIMATE_CREATED', // MACRO: DIAGNOSTIC_MANUFACTURER_PROCESSED

  ESTIMATE_SENT_TO_CUSTOMER: 'ESTIMATE_SENT_TO_CUSTOMER',
  FORCE_ESTIMATE_SENT_TO_CUSTOMER: 'FORCE_ESTIMATE_SENT_TO_CUSTOMER',

  ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER: 'ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER',
  FORCE_ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER:
    'FORCE_ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER',

  IN_REPARATION: 'IN_REPARATION',

  SENT_BACK_BY_REPAIRER: 'SENT_BACK_BY_REPAIRER',

  RECEIPT_AT_STORE: 'RECEIPT_AT_STORE',

  SENT_AVAILABLE_TO_CUSTOMER: 'SENT_AVAILABLE_TO_CUSTOMER',

  TAKEOVER_BY_CUSTOMER: 'TAKEOVER_BY_CUSTOMER',

  NETWORK_BILLING: 'NETWORK_BILLING',

  FINISHED: 'FINISHED',

  ABORT_BY_CUSTOMER: 'ABORT_BY_CUSTOMER',

  DELETED: 'DELETED'
}

export default RepairFileStatusDetailConstant
